<template>
  <VueHtml2pdf
    :show-layout="false"
    :float-layout="true"
    :enable-download="false"
    :preview-modal="false"
    filename="legal-document.pdf"
    :manual-pagination="true"
    :paginate-elements-by-height="0"
    :pdf-quality="2"
    pdf-format="legal"
    pdf-orientation="portrait"
    pdf-content-width="816px"
    @beforeDownload="beforeDownloadHandler"
    ref="html2PdfChunk"
  >
    <section slot="pdf-content">
      <div 
        v-for="(pair, idx) in chunkArray(chunkData, 2)" 
        :key="idx"
        class="page"
      >
        <div 
          v-for="(item, idx) in pair"
          :key="idx"
          class="page-item"
        >
          <div v-if="business" class="header">
            <div class="logo-container">
              <img 
                v-if="logo" 
                :src="logo" 
                crossorigin="anonymous"
                style="width: 100%; object-fit: contain;"
              />
            </div>
            <div class="business-info">
              <div class="info-row">
                <strong>{{ business.BusinessName?.toUpperCase() }}</strong>
              </div>
              <div class="info-row" v-if="keymaster == '47770e9a83f6f46af2a3d2b93fff710a'" style="text-transform: uppercase; font-size: 7pt;">
                <b>Suc. Santa Elena:</b> Calle Conchagua, Pte # 22, Urb. Madre Selva II, Antiguo Cuscatlán, La Libertad. <br> 
                <div class="business-phones">
                  <div class="phone">
                    Teléfono: 2246-4546
                  </div>
                  <div class="cellphone">
                    Celular: 7890-3428
                  </div> 
                </div>
                <b>Suc. Santa Rosa:</b> 16 Av. Norte y 3° Calle Pte. No. 2-16, Santa Tecla. La Libertad. El Salvador. <br>
                <div class="business-phones">
                  <div class="phone">
                    Teléfono: 2519-7851
                  </div>
                  <div class="cellphone">
                    Celular: 7850-4268
                  </div>
                </div>
              </div>
              <div v-else>
                {{ business.BusinessAddress?.toUpperCase() }}
              </div>
              <div class="info-row business-phones" v-if="keymaster !== '47770e9a83f6f46af2a3d2b93fff710a'">
                <div class="phone">
                  Teléfono: {{ business.BusinessPhone }}
                </div>
                <div class="cellphone">
                  Celular: {{ business.BusinessCellPhone }}
                </div>
              </div>
            </div>
          </div>
          <div class="customer-info">
            <div :style="{
              display: 'flex',
              flexDirection: 'column',
              marginRight: '16px',
            }">
              <div>Sr(a):</div>
              <div>Dirección:</div>
            </div>
            <div 
              :style="{
                display: 'flex',
                flexDirection: 'column',
              }"
            >
              <div>{{ item.veterinary_patient?.customer?.LegalName?.toUpperCase() }}</div>
              <div>{{ item.veterinary_patient?.customer?.LegalAddress?.toUpperCase()}}</div>
            </div>
          </div>
          <div style="margin: 20px 0">Estimado Cliente Sr(a): {{ item.veterinary_patient?.customer?.LegalName?.toUpperCase() }}</div>
          <div style="text-align: justify;">POR ESTE MEDIO LE RECORDAMOS QUE SU MASCOTA <b>{{ item.veterinary_patient?.NamePatient?.toUpperCase() }}</b> TIENE UNA CITA EN <b>{{ business.BusinessName?.toUpperCase() }}</b> PARA APLICAR: <b>{{ getService(item)?.toUpperCase() }}</b>, EN LA FECHA <b>{{ getDate(item) }}</b>. POR LO QUE LE ROGAMOS POR EL BIENESTAR DE USTED Y DE LOS SUYOS ACUDIR A LA CLÍNICA LO MÁS PRONTO POSIBLE.</div>
          <div
            style="margin: 20px 0;"
          >
            Atentamente: {{ business.BusinessName?.toUpperCase() }}
          </div>
          <div 
            style="text-align: center; margin: 20px 0; font-style: italic; text-transform: uppercase;"
            v-if="keymaster == '47770e9a83f6f46af2a3d2b93fff710a'" 
          >
            "Nosotros lo queremos tanto como usted"
          </div>
        </div>
      </div>
    </section>
  </VueHtml2pdf>
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf'

export default {
  name: 'PdfChunkRenderer',
  components: {
    VueHtml2pdf,
  },
  props: {
    chunkData: {
      type: Array,
      required: true
    },
    business: {
      type: Object,
      required: true
    },
    logo: {
      type: [String, null],
      default: null
    },
    keymaster: {
      type: String,
      required: true
    }
  },
  methods: {
    // --- Helper Methods (Copied from original component) ---
    getService(item) {
      if (item.typeN === 'Grooming') {
        return item?.TypeOfService.replace('DoctorPet ', '');
      } else if (item.typeN === 'Medications') {
        return item?.Medicine.replace('DoctorPet ', '');
      } else if (item.typeN === 'Surgery') {
        return item?.NotificationType.replace('DoctorPet ', '');
      }
      return ''
    },
    getDate(item) {
      if (item.typeN === 'Grooming' || item.typeN === 'Medications') {    
        return item.NotificationDate;
      } else if (item.typeN === 'Surgery') {
        return item.NotificationDate || item.SurgeryDate
      }
      return item.NotificationDate || ''
    },
    chunkArray(arr, chunkSize) {
      if (!arr || !Array.isArray(arr)) return [];
      const chunkedArray = [];
      for (let i = 0; i < arr.length; i += chunkSize) {
        chunkedArray.push(arr.slice(i, i + chunkSize));
      }
      return chunkedArray;
    },

    // --- Core Action ---
    /**
     * Public method to trigger PDF generation for this specific chunk.
     */
    generatePdf() {
      // Return a Promise that will be resolved/rejected in beforeDownloadHandler
      return new Promise((resolve, reject) => {
        this.resolvePdf = resolve;
        this.rejectPdf = reject;
        this.$refs.html2PdfChunk.generatePdf();
      });
    },

    /**
     * VueHtml2pdf callback: Captures the PDF stream for the current chunk.
     */
    async beforeDownloadHandler({ html2pdf, options, pdfContent }) {
      if (this.resolvePdf) {
        try {
          // Get the jsPDF instance (the core stream)
          const pdfInstance = await html2pdf().set(options).from(pdfContent).toPdf().get("pdf");
          
          // Create Blob from pdf instance
          const pdfBlob = await pdfInstance.output("blob");
          
          // Resolve the Promise in the parent component's queue with the Blob
          this.resolvePdf(pdfBlob);
        } catch (error) {
          console.error("Error in PdfChunkRenderer beforeDownloadHandler:", error);
          this.rejectPdf(error);
        } finally {
          this.resolvePdf = null;
          this.rejectPdf = null;
        }
      }
    },
  },
  // Data to hold the promise resolvers internally for flow control
  data() {
    return {
      resolvePdf: null,
      rejectPdf: null,
    }
  },
}
</script>

<style scoped>
/* Scoped styles are the same as before */
.page {
  display: flex;
  flex-direction: column;
  height: 1248px; /* Legal height minus margins */
  box-sizing: border-box;
  padding: 32px;
  width: 816px; /* Legal width */
}

.page:not(:first-child) {
  break-before: page;
}

.page-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  margin: 0;
  width: 100%;
  max-height: 50%; /* Allows 2 items per page */
  box-sizing: border-box;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 11pt;
  line-height: 1.75;
}

.page-item:first-child {
  border-bottom: 1px dashed black;
}

.header {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
}

.logo-container {
  display: flex;
  width: 300px;
  height: 170px;
  align-items: center;
  margin-right: 32px;
}

.business-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: 100%;
  margin: 20px 0;
}

.info-row {
  margin: 0;
}

.business-phones {
  display: flex;
  flex-direction: row;
}

.phone {
  margin-right: 24px;
}

.customer-info {
  display: flex;
  flex-direction: row;
  margin: 20px 0;
}
</style>